export const AppointmentStatuses = Object.freeze({
  PENDING_CARER_APPROVAL: 1,
  CARER_REJECTED: 2,
  OFFICE_CHANGED: 3,
  CARER_CHANGED: 4,
  ACCEPTED: 5,
  STARTED: 6,
  COMPLETED: 7,
  CANCELLED: 8,
});

export const PaymentTypes = Object.freeze({
  NONE: 'None',
  EFTPOS: 'EFTPOS',
  CASH: 'Cash',
  ACCOUNT: 'Account',
});

export const YesNoAllTypes = Object.freeze({
  ALL: 'All',
  YES: 'Yes',
  NO: 'No',
});

export const YesNoAllOptions: { id: string; name: string }[] = Object.values(YesNoAllTypes).map((value) => ({
  id: value,
  name: value,
}));

export const HighlightOptions = Object.freeze({
  TIMES: 'Times',
  DISTANCE: 'Distance',
});

export const AvailabilityOptions = Object.freeze({
  ALL: 'All',
  AVAILABLE: 'Available',
  UNAVAILABLE: 'Not Available',
});

export const PreferenceOptions = Object.freeze({
  PREFERRED: 'Preferred',
  HISTORICAL: 'Historical',
});

export const SortOptions = Object.freeze({
  ALPHA: 'Alphabetical',
  BIDDING: 'Bidding',
});

export const WeeklyPlannerDatasetOptions = Object.freeze({
  USER: 'Users',
  CLIENT: 'Clients',
});

export const WeeklyPlannerDateRangeOptions = Object.freeze({
  WEEKLY: 'Weekly',
  DAILY: 'Daily',
});

export const AppointmentConflictTypes = Object.freeze({
  PREFERENCE_CLASH: 'Preference Clash',
  TIME_CLASH: 'Time Clash',
  TRAVEL_CLASH: 'Travel Clash',
});

export const BillingTypes = {
  HOURLY: 'hourly',
  TRIP: 'trip',
  INVOICE: 'invoice',
  INVOICE_PLUS_10_PERCENT: 'invoice_plus_10_percent',
} as const;

export type BillingType = (typeof BillingTypes)[keyof typeof BillingTypes];

const BillingTypeLabels: Record<BillingType, string> = {
  [BillingTypes.HOURLY]: 'Hourly',
  [BillingTypes.TRIP]: 'Trip',
  [BillingTypes.INVOICE]: 'Invoice',
  [BillingTypes.INVOICE_PLUS_10_PERCENT]: 'Invoice + 10%',
} as const;

export const billingTypeOptions: { label: string; value: BillingType }[] = Object.values(BillingTypes).map((value) => ({
  label: BillingTypeLabels[value],
  value,
}));

export const isInvoiceBillingType = (billingType: BillingType): boolean => {
  return billingType === BillingTypes.INVOICE || billingType === BillingTypes.INVOICE_PLUS_10_PERCENT;
};

export const isTripBillingType = (billingType: BillingType): boolean => {
  return billingType === BillingTypes.TRIP;
};

// PACKAGE SCHEDULE FUNDING TYPES
export const PackageScheduleFundingTypes = Object.freeze({
  BROKERAGE: 1,
  HCP: 2,
  CHSP: 3,
  NDIS: 4,
  PRIVATE: 5,
  RESIDENTIAL: 6,
  DVA_VHC: 7,
  HACC: 8,
  CONTRACT: 9,
  NOT_DEFINED: 10,
  DVA_NURSING: 12,
});

export const SupportAtHomeFundingTypes = Object.freeze({
  SAH_QUARTERLY_CLIENT: 'ON',
  SAH_CASE_MANAGEMENT: 'CM',
  SAH_HOME_MODIFICATIONS: 'HM',
  SAH_ASSISTIVE_TECHNOLOGY: 'AT',
  SAH_RESTORATIVE_CARE: 'RC',
  SAH_END_OF_LIFE: 'EL',
  SAH_SPECIFIED_ASSISTIVE_TECHNOLOGY: 'AS',
});

export const ClientFormOptionGroups = Object.freeze({
  NAPS_ID: 'NAPSID',
});
